<style lang="scss" src='./CourseNewUser.scss' scoped></style>
<template src="./CourseNewUser.html" ></template>

<script>
  import GwPassword from '@/components/gwPassword/GwPassword.vue';
  import { mapMutations, mapState } from 'vuex';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required, password } from 'vee-validate/dist/rules';

  import { validateUsernameAndEmail, saveUser, updateUser, uploadUserPhotoV2 } from '@/api/index';

  import i18n from './../../../../../i18n';

  import { Models } from 'gw-js-lib';
  import { omit, pick } from 'lodash';

  extend('required', required);

  const getCleanUser = () => {
    return {...Models.M_user(), photo: {}};
  }

  export default {
    name: 'CourseNewUser',
    components: {
      ValidationProvider,
      ValidationObserver,
      GwPassword,
    },

    data() {
      return {
        user: getCleanUser(),
        confirmPassword: null,
        loading: {
          validatingUser: false,
        },
        activate_notifications: false,
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        course: (state) => state.setupData.course,
        editingUser: (state) => state.editingUser,
        userSelected: (state) => state.userSelected,
      }),
      isPasswordValid(){
      
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.*[0-9]).{8,}$/;    
      return regex.test(this.user.password);
    
    },
    },
    

    methods: {

      getUserType(type_id){

        let group = '';
        switch(type_id){
          case this.consts.UserType.ADMIN:
          case this.consts.UserType.OPERATIONS:
          case this.consts.UserType.AGENT:
          case this.consts.UserType.GROUNDWORX:
            group = this.consts.UserGroup.GROUNDWORX;
            break;
          default:
            group = this.consts.UserGroup.CUSTOMER;
        }

        let user_type = {
          'group': group,
          'name' : i18n.t('users.role_' + type_id),
          'type_id': type_id
        }

        return user_type;
      },

      async validateUser() {
        const validForm = await this.$refs.validator.validate().then((v) => v);
        if (validForm) {
          this.loading.validatingUser = true;
          if (this.editingUser) {
            await this.fnEditUser().finally(() => {
              this.loading.validatingUser = false;
            });
          } else {
            validateUsernameAndEmail(this.user.username, this.user.email).then(async () => {
              await this.fnSaveUser();
            }).finally(() => {
              this.loading.validatingUser = false;
            });
          }
          
        }
      },

      async fnSaveUser() {
        if (this.course && this.course.course_id) {
          await saveUser({ ...omit(this.user, ['photo']), course_id: this.course.course_id, activate_notifications: this.activate_notifications,})
                .then( async (user) => {
                  user = await this.uploadUserPhoto(user);
                  if(user.user_type.group == this.consts.UserGroup.GROUNDWORX){
                    user.hidden = true;
                  }else{
                    user.hidden = false;
                  }
                  this.addUser(user);
                  this.setShowNewUserPage(false);
                });
        } else {

          let userType = this.getUserType(this.user.type_id);

          this.user.user_type = userType;

          if(this.user.user_type.group == this.consts.UserGroup.GROUNDWORX){
            this.user.hidden = true;
          }else{
            this.user.hidden = false;
          }

          this.user.activate_notifications = this.activate_notifications;

          this.addUser(this.user);
          this.setShowNewUserPage(false);
        }
      },

      async fnEditUser() {
        const userAux = {...pick(this.user, Object.keys(getCleanUser()))};

        if (this.user && this.user.user_id) {
          await updateUser({ ...omit(userAux, ['photo'])}, this.user.user_id)
                .then( async (user) => {
                  user = await this.uploadUserPhoto(user);
                  this.updateUser(user);
                  this.setShowNewUserPage(false);
                });
        } else {
          
          let userType = this.getUserType(this.user.type_id);

          this.user.user_type = userType;

          if(this.user.user_type.group == this.consts.UserGroup.GROUNDWORX){
            this.user.hidden = true;
          }else{
            this.user.hidden = false;
          }

          this.updateUser(this.user);
          this.setShowNewUserPage(false);
        }
      },
      
      async uploadUserPhoto(userSaved) {
        this.loading.validatingUser = true;
        if (this.user.photo && this.user.photo.url) {
          await uploadUserPhotoV2(userSaved.user_id, this.user.photo).then(userWithPhoto => {
            if (userWithPhoto) {
              // Refactor service to upload user photos and also refactor uploadPhoto to return just data
              userSaved = userWithPhoto;
            }
          });
        }
        this.loading.validatingUser = false;
        return userSaved;
      },

      onNewPhotoSelected(event) {
        this.G_createUrlFromFile(event, (mImage)=> {
          this.user.photo = mImage;
        });
      },

      ...mapMutations('CourseSetup', ['setShowNewUserPage', 'addUser', 'updateUser']),
    },

    activated() {
    },

    beforeCreate() {
      extend('password', {
        params: ['target'],
        validate(value, { target }) {
          return value === target;
        },
        message: this.$t('login.passwordNotMatch')
      });
    },

    mounted() {
      if (this.editingUser) {
        if (this.userSelected.user_id) {
          // We need photo attr for existing users
          this.user = {...this.userSelected, photo: {}};
        } else {
          this.user = this.userSelected;
        }
      } else {
        this.user = getCleanUser();
      }
    },

    beforeDestroy() {},
  };

</script>
